import gql from 'graphql-tag'

export const ORGANISATIONSHIPPINGLINESELECTIONS_QUERY = gql`
query OrganisationCruiseCompassShippingLineSelections {
  organisationShippingLineSelections {
    results {
      id
      shippingLine {
        id
        name
      }
    }
  }
}
`

export const ORGANISATIONSHIPPINGLINESELECTIONS_CREATE_MUTATION = gql`
mutation CreateOrganisationCruiseCompassShippingLineSelection($input: OrganisationCruiseCompassShippingLineSelectionCreateGenericType!) {
  createOrganisationShippingLineSelection(input: $input) {
    organisationcruisecompassshippinglineselection {
      id
      shippingLine {
        id
        name
      }
    }
    ok
    errors {
      field
      messages
    }
  }
}
`

export const ORGANISATIONSHIPPINGLINESELECTIONS_DELETE_MUTATION = gql`
mutation DeleteOrganisationCruiseCompassShippingLineSelection($id: ID!) {
  deleteOrganisationShippingLineSelection(id: $id) {
    organisationcruisecompassshippinglineselection {
      id
    }
    ok
    errors {
      field
      messages
    }
  }
}
`
